<script setup lang="ts">
import EditorFooter from './EditorFooter.vue'

const { t } = useI18n()

defineProps<{ disabled?: boolean }>()

const visible = defineModel<boolean>('visible', { required: true })

const emit = defineEmits<{ cancel: []; save: [] }>()
</script>

<template>
  <EditorFooter>
    <div class="flex w-full flex-wrap items-center justify-end gap-2">
      <label for="brand-app-content-visible" class="mr-auto flex cursor-pointer items-center gap-2 text-sm font-medium">
        <Switch id="brand-app-content-visible" v-model="visible" />
        {{ t('pages.loyaltySupports.webapp.editor.footer.showInApp') }}
      </label>
      <Button variant="ghost" @click="emit('cancel')">{{ t('global.words.cancel') }}</Button>
      <Button variant="default-primary" :disabled="disabled" @click="emit('save')">{{
        t('global.words.validate')
      }}</Button>
    </div>
  </EditorFooter>
</template>
